import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesWhatsAppAdProducts } from "../../constants";
import { IAdProduct } from "../../whatsappAdProducts.types";
import { UpdateAdProductBody } from "./updateAdProduct.types";

export const requestUpdateAdProduct = async ({
  id,
  body
}: UpdateAdProductBody): Promise<IAdProduct> => {
  return await instance.patch(
    buildUrl(ApiRoutesWhatsAppAdProducts.AdProducts, id),
    body
  );
};
